import { render, staticRenderFns } from "./chat-input.vue?vue&type=template&id=071f8254&scoped=true&"
import script from "./chat-input.vue?vue&type=script&lang=js&"
export * from "./chat-input.vue?vue&type=script&lang=js&"
import style0 from "./chat-input.vue?vue&type=style&index=0&id=071f8254&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071f8254",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VProgressCircular,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('071f8254')) {
      api.createRecord('071f8254', component.options)
    } else {
      api.reload('071f8254', component.options)
    }
    module.hot.accept("./chat-input.vue?vue&type=template&id=071f8254&scoped=true&", function () {
      api.rerender('071f8254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/chat-input/chat-input.vue"
export default component.exports